module.exports = __webpack_public_path__ + "img/board6-GLX-purple-49.c56dac5d.jpg";